'use client';
type LoyaltyUser = {
  _id: string;
  email: string;
  firstName: string;
  lastName: string;
  telephone: string;
  gender: 'Male' | 'Female' | string;
  date_of_birth: string;
  points: number;
  amountSpent: number;
  tier: 'Ruby' | 'Bronze' | 'Silver' | 'Gold' | 'Diamond' | 'Platinum' | string;
  reachedMilestone: boolean;
  redeemedTiers: string[];
};

type Reward = {
  _id: string;
  name: string;
  tier: 'Ruby' | 'Bronze' | 'Silver' | 'Gold' | 'Diamond' | 'Platinum' | string;
  description: string;
  pointsRequired: number;
  imageUrl: string;
};

import { CheckCircleIcon, CircleStackIcon } from '@heroicons/react/24/solid';
import {
  LoginWithPhone,
  RegisterEmailOrPhone,
  updateUser,
  verifyOtp,
} from '@/services/auth.api';
import { getErrorMessge, readableDate } from '@/utils/helpers';
import { use, useEffect, useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';

import AppStorage from '@/utils/helpers';
import AuthModal from '@/components/AuthModal';
import { BarLoader } from 'react-spinners';
import BillingInformation from '@/components/global/NewAuthFlow';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import DeleteAccountButton from '@/components/my-account/DeleteAccountButton';
import Food from '@/assets/img-food.jpeg';
import { GetOrders } from '@/services/order.api';
import Image from 'next/image';
import Link from 'next/link';
import Modal from '@/components/global/Modal';
import OrderList from '@/components/my-account/OrderList';
import { clearCart } from '@/redux/slices/cart.slice';
import imgItem from '@/assets/box.png';
import { signinUser } from '@/redux/slices/auth.slice';
import { toast } from 'react-toastify';
import { useAppSelector } from '@/redux/hooks';
import { useDispatch } from 'react-redux';
import axiosInstance from '@/utils/https';
import View from '@/components/loyalty/View';
import Welcome from '@/components/loyalty/Welcome';
import UserProfile from '@/components/my-account/UserProfile';
import gift from '@/assets/reward.png';
import profile from '@/assets/account_profile.png';
import logout from '@/assets/logout.png';

export default function AccountPage() {
  const searchParams = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState<any[]>([]);
  const [verifyTab, setVerifyTab] = useState<'verify' | ''>('');
  const [activePage, setActivePage] = useState('orders');
  const dispatch = useDispatch();
  const { user } = useAppSelector((state: any) => state.auth);
  const router = useRouter();
  const [loyaltyUser, setLoyaltyUser] = useState<LoyaltyUser | null>(null);

  useEffect(() => {
    const paramValueOne = searchParams.get('trxref');
    const paramValueTwo = searchParams.get('reference');

    if (paramValueOne && paramValueTwo) {
      AppStorage.remove('cart');
      AppStorage.remove('paystackUrl');
      dispatch(clearCart());
    }
  }, []);

  const [openLogin, setOpenLogin] = useState({ open: false, state: '' });

  const submit = async (phoneNumber: string, fullName: string) => {
    const nameParts = fullName.trim().split(' ');
    if (nameParts.length < 2) {
      toast.error('Please enter both first and last name');
      return;
    }
    if(phoneNumber.length < 10 || phoneNumber.length > 11) {
      toast.error('Please enter a valid phone number');
      return;
    }
    if (phoneNumber.startsWith('+234') || phoneNumber.startsWith('234')) {
      toast.error('Please enter your phone number without the country code.');
      return;
    }
    try {
      setLoading(true);
      // const response = await RegisterEmailOrPhone({ emailOrPhone: payload });
      const response = await LoginWithPhone({
        telephone: phoneNumber,
        first_name: nameParts[0],
        last_name: nameParts[1],
      });

      if (response._id) {
        AppStorage.save('atk', response.accessToken);
        dispatch(signinUser(response));
        AppStorage.remove('email');
        toast.success('Login successful!');
        setOpenModal(false);
        return;
      }
      AppStorage.save('email', phoneNumber);
      toast.info(response.message);
      setVerifyTab('verify');
    } catch (error: any) {
      console.error(error);
      const errorMsg = getErrorMessge(error);
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  // const verify = async (emailOrPhone: string, otp: string, payload: string) => {
  //   const nameParts = payload.trim().split(' ');
  //   if (nameParts.length < 2) {
  //     toast.error('Please enter both first and last name');
  //     return;
  //   }
  //   try {
  //     setLoading(true);
  //     const response = await verifyOtp({
  //       emailOrPhone,
  //       otp,
  //     });
  //     if (response.user) {
  //       const update = await updateUser({
  //         emailOrPhone,
  //         firstName: nameParts[0],
  //         lastName: nameParts[1],
  //       });
  //       if (!update.user) {
  //         toast.error(response.message);
  //         store.remove('atk');
  //         setVerifyTab('');
  //         throw Error("couldn't checkout order");
  //       }
  //       //use success handler to set the token, if token is present.
  //       AppStorage.remove('email');
  //       dispatch(signinUser(response));
  //       toast.success('Registration successful!');
  //       setOpenModal(false);
  //       return;
  //     }
  //     toast.info(response.message);
  //     setVerifyTab('');
  //   } catch (error: any) {
  //     console.error(error);
  //     const errorMsg = getErrorMessge(error);
  //     toast.error(errorMsg);
  //     setVerifyTab('');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const [selectedTab, setSelectedTab] = useState('all');
  const [displayList, setDisplayList] = useState<any>();
  const [openModal, setOpenModal] = useState(false);
  const [oPenLoyalty, setOPenLoyalty] = useState<boolean>(false);
  const [amount, setAmount] = useState<number | null>(0);
  const [rewards, setRewards] = useState<Reward[]>([]);
  const [requiredPoints, setRequiredPoints] = useState<number | null>(null);
  const [pointTier, setPointTier] = useState<string | null>(null);
  const [latestOrderId, setLatestOrderId] = useState<string | null>(null);

  const getOrders = async () => {
    try {
      setLoading(true);
      const res = await GetOrders();

      const sorted = res.sort((a: any, b: any) => {
        const dateA: any = new Date(a.createdAt);
        const dateB: any = new Date(b.createdAt);

        return dateB - dateA;
      });

      setOrders(sorted);
      setDisplayList(sorted);
    } catch (error) {
      const err = getErrorMessge(error);
      if (err === 'Unauthorized') return;
      toast.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const redirect = AppStorage.get('redirect');
    getOrders();
    if (user) {
      fetchLoyaltyUser(user.telephone);
    }
    if (redirect) {
      setActivePage('loyalty');
      AppStorage.remove('redirect');
    }
  }, [user]);

  useEffect(() => {
    if (selectedTab === 'all') {
      setDisplayList(orders);
    } else if (selectedTab === 'incoming') {
      const incoming = orders.filter(
        (order: any) => order.status === 'IN_TRANSIT'
      );
      setDisplayList(incoming);
    } else if (selectedTab === 'delivered') {
      const delivered = orders.filter(
        (order: any) =>
          order.status === 'PICKED_UP_BY_CUSTOMER' ||
          order.status === 'DELIVERED' ||
          order.status === 'READY_FOR_PICKUP'
      );

      setDisplayList(delivered);
    }
  }, [selectedTab]);

  useEffect(() => {
    const confirmOrderPayment = async () => {
      if (!orders || orders.length === 0) return;

      const latestOrderId = AppStorage.get('latestOrderId');
      const orderCheck = orders[0]._id.toString() === latestOrderId;
      if (orderCheck) return;

      const latestOrder = orders[0];
      const purchaseAmount =
        latestOrder?.totalAmount - latestOrder?.deliveryFee;
      setAmount(purchaseAmount);
      setLatestOrderId(latestOrder?._id);

      if (latestOrder.status === 'PROCESSING_PENDING') {
        const loyaltyUser = await fetchLoyaltyUser(user.telephone);
        if (loyaltyUser) {
          const orderPoint = (purchaseAmount / 1000).toFixed(1);
          toast.success(
            `Based on your latest order, you earned ${orderPoint} points`
          );
          AppStorage.save('latestOrderId', latestOrder?._id.toString());
        } else {
          const modalDuration = AppStorage.get('loyaltyModalDuration');

          const timePassed = Date.now() - Number(modalDuration);
          const hrs = 3 * 60 * 60 * 1000;
          if (!modalDuration || timePassed < hrs) {
            toast.info('You are not a loyalty user yet');
            setOPenLoyalty(true);
            AppStorage.save('loyaltyModalDuration', Date.now().toString());
          }
        }
      }
    };

    confirmOrderPayment();
  }, [orders]);

  const fetchLoyaltyUser = async (telephone: string) => {
    const url = `api/v1/loyalty/tele/${telephone}`;
    try {
      const res = await axiosInstance.get(url);
      setLoyaltyUser(res.data);
      fetchRewards(res.data.points);
      // AppStorage.save('loyaltyUser', JSON.stringify(res.data));
      return res.data;
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRewards = async (points: number) => {
    try {
      const res = await axiosInstance.get<Reward[]>('api/v1/rewards');
      setRewards(res.data);
      getNextRewardTier(res.data, points ?? 0);
    } catch (error) {
      console.error('Error fetching rewards:', error);
    }
  };

  function getNextRewardTier(rewards: Reward[], points: number) {
    const eligible = rewards
      .filter((r) => r.pointsRequired <= points)
      .sort((a, b) => a.pointsRequired - b.pointsRequired);
    setRequiredPoints(
      eligible.length > 0 ? eligible[eligible.length - 1].pointsRequired : null
    );
    setPointTier(
      eligible.length > 0 ? eligible[eligible.length - 1].tier : null
    );
    return;
  }

  const renderPage = () => {
    switch (activePage) {
      case 'profile':
        return <UserProfile user={user} />;
      case 'orders':
        return (
          <div className="py-8 flex flex-col gap-10">
            <Modal
              openModal={oPenLoyalty}
              closeModal={() => setOPenLoyalty(false)}
              modalTitle=""
              closeButton={true}
              shouldCloseOnOverlayClick={true}
              darkTitle={false}
            >
              <div className="flex flex-col items-center justify-center gap-6">
                <Image src={gift} alt="reward" />
                <p className="text-crunchies-red text-xl sm:text-2xl font-semibold">
                  You have a reward
                </p>

                <p className="text-[#475569] text-sm sm:text-base font-medium text-center">
                  Dear Cruncher, <br />
                  You are eligible for our loyalty program, <br />
                  where you get rewarded for your patronage. <br />
                  We can't wait to show you lots of love!
                </p>
              </div>

              <button
                onClick={() => {
                  setOPenLoyalty(false);
                  goToForm();
                }}
                className="text-white text-base font-medium bg-crunchies-red shadow py-3 px-6 rounded-lg text-center"
              >
                Get my reward
              </button>
            </Modal>

            <div>
              <div className="flex w-full md:w-[60%] 2xl:w-[40%]">
                <p
                  onClick={() => setSelectedTab('all')}
                  className={`grow cursor-pointer ${
                    selectedTab === 'all'
                      ? ' text-primary-400 font-poppinsBold border-b border-primary-400'
                      : 'text-gray-500 font-poppinsRegular border-grey  border-b '
                  } py-1 px-2 md:px-5`}
                >
                  All orders{' '}
                </p>
                <p
                  onClick={() => setSelectedTab('incoming')}
                  className={`grow cursor-pointer ${
                    selectedTab === 'incoming'
                      ? 'text-primary-400 font-poppinsBold border-b border-primary-400'
                      : 'text-gray-500 font-poppinsRegular border-grey  border-b '
                  } py-1 px-2 md:px-5`}
                >
                  Incoming
                </p>
                <p
                  onClick={() => setSelectedTab('delivered')}
                  className={`grow cursor-pointer ${
                    selectedTab === 'delivered'
                      ? 'text-primary-400 font-poppinsBold border-b border-primary-400'
                      : 'text-gray-500 font-poppinsRegular border-grey  border-b '
                  } py-1 px-2 md:px-5`}
                >
                  Delivered
                </p>
              </div>
              <div className="p-3 md:p-5 w-full md:w-[70%]">
                {displayList?.length === 0 ? (
                  <div>
                    <p className="text-[#555] font-poppinsRegular my-5 text-center">
                      No order in this category yet!
                    </p>
                  </div>
                ) : (
                  displayList?.map((item: any, index: any) => {
                    const date = readableDate(item?.createdAt);
                    return (
                      <OrderList
                        index={index}
                        date={date}
                        item={item}
                        key={index}
                      />
                    );
                  })
                )}
              </div>
            </div>
          </div>
        );
      case 'loyalty':
        return (
          <>
            {loyaltyUser ? (
              <>
                <View
                  loyaltyUser={loyaltyUser}
                  rewards={rewards}
                  requiredPoints={requiredPoints}
                  pointTier={pointTier}
                />
              </>
            ) : (
              <Welcome fetchLoyaltyUser={fetchLoyaltyUser} />
            )}
          </>
        );
      default:
        return null;
    }
  };

  const goToForm = () => {
    AppStorage.save('amountSpent', amount);
    AppStorage.save('latestOrderId', latestOrderId?.toString());
    setActivePage('loyalty');
  };

  if (loading) {
    return (
      <div className="h-screen w-screen flex justify-center items-center ">
        <BarLoader color="#ca1611" />
      </div>
    );
  }

  return (
    <>
      <article>
        {user && (
          <div
            onClick={() => {
              AppStorage.remove('atk');
              AppStorage.remove('user');
              toast.success('Logged out successfully');
              window.location.href = '/account';
            }}
            className="flex items-center gap-3 py-3 px-4 sm:px-36 place-content-end text-sm text-crunchies-red font-medium mt-4"
          >
            <p>Log out</p>
            <Image src={logout} alt="log out" />
          </div>
        )}
        <section className="flex flex-col px-4 lg:px-36 2xl:px-72 py-8 lg:py-16 mt-8">
          <nav className="w-full border-b border-gray-200">
            <ul className="flex justify-between items-center text-sm text-gray-600">
              {[
                { label: 'Profile', key: 'profile' },
                { label: 'My Orders', key: 'orders' },
                { label: 'Loyalty profile', key: 'loyalty' },
              ].map(({ label, key }) => (
                <li
                  key={key}
                  onClick={() => setActivePage(key)}
                  className={`cursor-pointer px-4 py-3 transition duration-200 border-b-2 
                              ${
                                activePage === key
                                  ? 'text-red-500 font-semibold border-red-500'
                                  : 'border-transparent hover:text-red-400 hover:border-red-400'
                              }
                            `}
                >
                  {label}
                </li>
              ))}
            </ul>
          </nav>

          {user ? (
            renderPage()
          ) : (
            <div className="h-96 p-3 md:p-5 w-full flex flex-col items-center justify-center gap-10">
              <Image src={profile} alt="acount_profile" priority />
              <div className="flex flex-col gap-2">
                <p className="text-[#475569] font-poppinsRegular text-center">
                  You have not signed in, click sign in to view your{' '}
                  {activePage}
                </p>
                <button
                  type="button"
                  className="text-crunchies-red bg-white cursor-pointer px-6 py-4 rounded-lg"
                  onClick={() => setOpenModal(true)}
                >
                  Sign in
                </button>
              </div>
            </div>
          )}
        </section>
        <Modal
          openModal={openModal}
          modalTitle="Login"
          closeModal={() => setOpenModal(false)}
          shouldCloseOnOverlayClick={true}
        >
          <BillingInformation onSubmit={submit} title="Register/Login" />
        </Modal>
        {/* <AuthModal
          open={openLogin}
          closeModal={() => setOpenLogin({ open: false, state: '' })}
          swicthToRegister={() =>
            setOpenLogin({ open: true, state: 'register' })
          }
          switchToLogin={() => setOpenLogin({ open: true, state: 'login' })}
        /> */}
      </article>
    </>
  );
}
